<section
  class="tournament-group-skeleton sb-card-shell"
  aria-hidden="true"
  [style.--quick-column-count]="quickColumnIndexes().length"
>
  <div class="tournament-group-skeleton__table">
    <header class="tournament-group-skeleton__header">
      <div class="tournament-group-skeleton__heading">
        <span class="tournament-group-skeleton__flag"></span>

        <div class="tournament-group-skeleton__titles">
          <span class="tournament-group-skeleton__bar tournament-group-skeleton__bar--country"></span>
          <span class="tournament-group-skeleton__bar tournament-group-skeleton__bar--name"></span>
        </div>
      </div>

      <div class="tournament-group-skeleton__market">
        @for (column of quickColumnIndexes(); track column) {
          <span class="tournament-group-skeleton__bar tournament-group-skeleton__bar--market"></span>
        }
      </div>
      <span class="tournament-group-skeleton__toggle"></span>
    </header>

    <div class="tournament-group-skeleton__content">
      @for (row of rowIndexes(); track row) {
        <div class="tournament-group-skeleton__row">
          <div class="tournament-group-skeleton__info">
            <div class="tournament-group-skeleton__meta">
              <span class="tournament-group-skeleton__bar tournament-group-skeleton__bar--time"></span>

              @if (row === 0) {
                <span class="tournament-group-skeleton__bar tournament-group-skeleton__bar--status"></span>
              }
            </div>

            <div class="tournament-group-skeleton__teams">
              <span class="tournament-group-skeleton__bar tournament-group-skeleton__bar--team"></span>
              <span
                class="tournament-group-skeleton__bar tournament-group-skeleton__bar--team"
                [class.tournament-group-skeleton__bar--team-short]="row === 1"
              ></span>
            </div>

            <div class="tournament-group-skeleton__scores">
              <span class="tournament-group-skeleton__bar tournament-group-skeleton__bar--score"></span>
              <span class="tournament-group-skeleton__bar tournament-group-skeleton__bar--score"></span>
            </div>
          </div>

          @for (column of quickColumnIndexes(); track column) {
            <span class="tournament-group-skeleton__odd"></span>
          }

          <span class="tournament-group-skeleton__more"></span>
        </div>
      }
    </div>
  </div>
</section>
